const modalReqApp = {
  namespaced: true,
  state: () => ({
    modalExtendSap: false,
    modalBlockVendor: false,
    modalUnblockVendor: false,

    modalViewExtend: false,
    modalViewBlock: false,
    modalViewUnblock: false,

    modalReview: false,
    modalDeleteVendor: false,
  }),
  mutations: {
    SET_VALUE(state, data) {
      state[data.name] = data.value
    },
    CLOSE_ALL(state, data) {
      state.modalExtendSap = false
      state.modalBlockVendor = false
      state.modalUnblockVendor = false
      state.modalViewExtend = false
      state.modalViewBlock = false
      state.modalViewUnblock = false
      state.modalReview = false
    },
  },
  actions: {},
}

export default modalReqApp
